<div class="p-plan-table js-plan-table01-item" [ngClass]="{ 'grey-bg': !isPlanValid }">
  <div class="p-plan-table__contents">
    <div class="p-plan-table__scroll">
      <div class="p-plan-table__scroll-view">
        <div class="p-plan-table__scroll-inner js-plan-table01-scroll">
          <table class="c-plan-table01 c-plan-table01--4col js-plan-table01">
            <caption class="u-visually-hidden" [innerHTML]="'label.rule' | staticMsg"></caption>
            <thead class="c-plan-table01__head">
              <tr class="c-plan-table01__inner">
                <td class="c-plan-table01__col"><div class="c-plan-table01__col-inner"></div></td>
                <th class="c-plan-table01__col" scope="col">
                  <div class="c-plan-table01__col-inner">
                    <div class="c-plan-table01__col-item c-plan-table01__col--em">
                      <span class="c-flight-info01__title-airport">
                        <span class="c-flight-info01__title-airport-departure c-loading-bar__line">
                          <span class="c-flight-info01__title-airport-to"> </span>
                        </span>
                        <span class="c-flight-info01__title-airport-arrival c-loading-bar__line"> </span>
                      </span>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="c-plan-table01__body">
              <tr class="c-plan-table01__inner">
                <th class="c-plan-table01__col" scope="row">
                  <div class="c-plan-table01__col-inner">
                    <div
                      class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                      [innerHTML]="'label.freeBaggage2' | staticMsg"
                    ></div>
                  </div>
                </th>
                <td class="c-plan-table01__col">
                  <div class="c-plan-table01__col-inner">
                    <div class="c-plan-table01__col-item c-plan-table01__col-item--fs16">
                      <span class="c-plan-table01__icon-available">
                        <span class="c-plan-table01__icon-available-image c-loading-bar__line"> </span>
                        <span class="c-plan-table01__icon-available-text"></span>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="c-plan-table01__inner">
                <th class="c-plan-table01__col" scope="row">
                  <div class="c-plan-table01__col-inner">
                    <div class="c-plan-table01__col-item--gray60" [innerHTML]="'label.firstBaggage' | staticMsg"></div>
                  </div>
                </th>
                <td class="c-plan-table01__col">
                  <div class="c-plan-table01__col-inner">
                    <div class="c-plan-table01__col-item c-plan-table01__col-item--fs16">
                      <span class="c-plan-table01__icon-add">
                        <span class="c-plan-table01__icon-add-image c-loading-bar__line"> </span>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
